<template>
<b-overlay :show="show" rounded="sm">
  <b-container fluid class="bg-white">
    <b-row><b-col>&nbsp;</b-col></b-row>
    <b-row class="mb-3">
      <b-col>
        <h3 tabindex="0">{{acao === 'visualizar' ? 'Visualizar Configuração da Conferência' : 'Configurar Conferência'}}</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="2">&nbsp;</b-col>
      <b-col sm="8">
        <b-row>
          <b-col sm="_">
            <b-row align-h="end">
              <b-button pill variant="success">1</b-button>
            </b-row>
          </b-col>
          <b-col><hr/></b-col>
          <b-col sm="_">
            <b-row align-h="center">
              <b-button pill variant="success">2</b-button>
            </b-row>
          </b-col>
          <b-col><hr/></b-col>
          <b-col sm="_">
            <b-row align-h="center">
              <b-button pill variant="primary">3</b-button>
            </b-row>
          </b-col>
          <b-col><hr/></b-col>
          <b-col sm="_">
            <b-row align-h="start">
              <b-button pill variant="success">4</b-button>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col sm="12">
       <b-row>
          <b-col tabindex="0" sm="3">
            <b-row align-h="around">Dados da Conferência</b-row>
          </b-col>
          <b-col tabindex="0" sm="3">
            <b-row align-h="around">Datas da Conferência</b-row>
          </b-col>
          <b-col tabindex="0" sm="3">
            <b-row align-h="around">Pós-Conferência</b-row>
          </b-col>
          <b-col tabindex="0" sm="2">
            <b-row align-h="center">Texto Apresentação</b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-form @submit.stop.prevent="salvar">
      <b-row class="mb-2">
        <b-col>
          <h5 tabindex="0">Quando a conferência for concluída, o sistema deve manter a exibição dos módulos: *</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table selectable select-mode="multi" id="modulos" :fields="campos" :items="modulos" :per-page="totalPorPagina" :current-page="paginaAtual" small bordered outlined>
            <template #cell(selecionado)="data"><b-form-checkbox v-model="data.item.selecionado" @change="alternarSelecionado(data.item.modulo_id)" :disabled="acao === 'visualizar'"/></template>
            <template #cell(somente_leitura)="data"><b-form-checkbox v-model="data.item.somente_leitura" @change="alternarSomenteLeitura(data.item.modulo_id)" :disabled="acao === 'visualizar'"/></template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col><b-pagination tabindex="0" v-model="paginaAtual" :total-rows="modulos.length" :per-page="totalPorPagina" aria-controls="modulos" v-show="modulos.length > 0"/></b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col tabindex="0">Exibindo página {{paginaAtual}} de {{Math.floor(modulos.length / totalPorPagina) + (modulos.length % totalPorPagina > 0 ? 1 : 0)}}, total de {{modulos.length}} registro{{modulos.length > 1 ? 's' : ''}}.</b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-row no-gutters>
            <b-button @click="voltar">
              <i class="fa fa-arrow-left"/>&nbsp;&nbsp;Voltar
            </b-button>
          </b-row>
        </b-col>
        <b-col sm="6">
          <b-row no-gutters align-h="end">
            <b-button type="submit" variant="primary">
              <i class="fa fa-floppy-o"/>&nbsp;&nbsp;{{acao === 'visualizar' ? 'Fechar' : 'Salvar e Avançar'}}
            </b-button>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
    <b-row><b-col>&nbsp;</b-col></b-row>
  </b-container>
  </b-overlay>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import SessionStorage from '@/services/session-storage'

export default {
  data () {
    return {
      acao: this.$route.params.acao,
      totalPorPagina: 10,
      paginaAtual: 1,
      show: false,
      campos: [
        {key: 'selecionado', label: 'Selecionar', sortable: false, tdClass: 'centro', thClass: 'centro'},
        {key: 'nome', label: 'Módulo', sortable: false},
        {key: 'somente_leitura', label: 'Somente Leitura', sortable: false, tdClass: 'centro', thClass: 'centro'}
      ],
      modulos: []
    }
  },
  computed: {
    ...mapState({
      usuario: state => state.usuario.usuario,
      configurarConferencia: state => state.conferencia.configurarConferencia,
      mensagemConferencia: state => state.conferencia.mensagem
    })
  },
  mounted () {
    this.$store.dispatch('setConferencia', {
      'conferencia_id': SessionStorage.get('conferencia_atual_id'),
      'conferencia_nome': SessionStorage.get('conferencia_atual_nome')
    })

    Vue.http.post('api/configurarConferencia/buscar', {conferencia_id: this.configurarConferencia.conferencia_id}).then(response => {
      if (response.body.success && response.body.data.length > 0) {
        this.$store.dispatch('setConfigurarConferencia', response.body.data[0])
      }
    })

    if (this.mensagemConferencia) {
      this.sucesso(this.mensagemConferencia)
      this.$store.commit('setMensagemConferencia', null)
    }

    Vue.http.get('api/configurarConferencia/buscarModulos/' + this.configurarConferencia.conferencia_id).then(response => {
      if (response.body.success && response.body.data.length > 0) {
        let modulos = response.body.data

        this.modulos = []
        for (let i = 0; i < modulos.length; i++) {
          let modulo = {
            modulo_id: modulos[i].modulo_id,
            nome: modulos[i].nome,
            modulo_configurar_conferencia_id: modulos[i].modulo_configurar_conferencia_id,
            configurar_conferencia_id: modulos[i].configurar_conferencia_id ? modulos[i].configurar_conferencia_id : this.id
          }

          if (modulos[i].somente_leitura) {
            modulo.somente_leitura = modulos[i].somente_leitura
          } else {
            modulo.somente_leitura = false
          }

          if (modulos[i].modulo_configurar_conferencia_id) {
            modulo.selecionado = modulos[i].modulo_configurar_conferencia_id > 0
          } else {
            modulo.selecionado = false
          }

          this.modulos.push(modulo)
        }
      }
    })
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    sucesso (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Sucesso',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'info'
      })
    },
    erro (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Erro',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'danger'
      })
    },
    alternarSelecionado (moduloId) {
      let index = -1

      for (let i = 0; i < this.modulos.length && index === -1; i++) {
        index = this.modulos[i].modulo_id === moduloId ? i : -1
      }

      if (index >= 0 && this.modulos[index].selecionado) {
        this.modulos[index].somente_leitura = false
      }
    },
    alternarSomenteLeitura (moduloId) {
      let index = -1

      for (let i = 0; i < this.modulos.length && index === -1; i++) {
        index = this.modulos[i].modulo_id === moduloId ? i : -1
      }

      if (index >= 0 && !this.modulos[index].somente_leitura) {
        this.modulos[index].selecionado = true
      }
    },
    voltar () {
      if (!this.configurarConferencia.situacao || this.configurarConferencia.situacao !== 'Finalizada' || this.acao === 'visualizar') {
        this.navigate('/configurarConferencia/passo2/' + this.acao)
      }
    },
    salvar () {
      if (this.acao === 'visualizar') {
        this.navigate('/configurarConferencia/gerenciar')
      } else {
        let dados = {
          id: this.configurarConferencia.id,
          situacao: this.configurarConferencia.situacao ? this.configurarConferencia.situacao : 'Rascunho',
          user_id: SessionStorage.get('usuario'),
          acao: this.acao === 'cadastrar' ? 'Cadastro da Configuração de Conferência' : 'Edição da Configuração de Conferência',
          modulos: this.modulos
        }

        for (let i = 0; i < this.modulos.length; i++) {
          if (this.modulos[i].selecionado) {
            this.modulos[i].configurar_conferencia_id = this.configurarConferencia.id
          }
        }
        this.show = true
        this.configurarConferencia.situacao = dados.situacao
        Vue.http.post('api/configurarConferencia/salvar3', dados).then(response => {
          this.show = false  
          if (response.body.success) {  
                this.$store.commit('setMensagemConferencia', 'Dados salvos com sucesso!')
                this.navigate('/configurarConferencia/passo4/' + this.$route.params.acao)            
          }
        })       
      }
    }
  }
}
</script>

<style>
  .centro {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/conferencia/Passo3.vue